/**
 * THIS FILE IS AUTOGENERATED. DO NOT EDIT.
 * To regenerate these files after changing A/B test configs, run this command:
 * `npm run generate-ab-tests`
 */

import {
  __abTest_base,
  __useAbTest_base,
  __inWinnerHoldout_base,
} from 'js/ab_tests/ab_test';

export const TEST_CONFIG = {
  active: false,
  finished: false,
  alternatives: [
    {
      name: 'control',
      percent: 83,
    },
    {
      name: 'bundle_grid_v6',
      percent: 1,
    },
    {
      name: 'rotating_preview_v7',
      percent: 1,
    },
    {
      name: 'source_anchor_v8',
      percent: 1,
    },
    {
      name: 'first_bullet_personalization_v9',
      percent: 1,
    },
    {
      name: 'blurred_hidden_thumbs_v10',
      percent: 1,
    },
    {
      name: 'bucket_badges_v14',
      percent: 1,
    },
    {
      name: 'trust_signal_v18',
      percent: 1,
    },
    {
      name: 'guarantee_badge_v19',
      percent: 1,
    },
    {
      name: 'fallback_first_r1',
      percent: 1,
    },
    {
      name: 'transactional_first_r2',
      percent: 1,
    },
    {
      name: 'social_proof_r3',
      percent: 1,
    },
    {
      name: 'no_modal_inline_r4',
      percent: 1,
    },
    {
      name: 'premium_preview_r5',
      percent: 1,
    },
    {
      name: 'just_this_paper_r6',
      percent: 1,
    },
    {
      name: 'post_download_r7',
      percent: 1,
    },
    {
      name: 'personalization_gate_r8',
      percent: 1,
    },
  ],
} as const;

/**
 * Synchronously returns the variant for this A/B test:
 * bulk_download_2026_q2_modal_mechanics_smoke_test
 *
 * Returns the bucket based on the current logged-in user id.
 * This function also makes a call to the server to bucket
 * the user server-side, but does not return the response.
 *
 * Once a user is bucketed, their variant for the test
 * is stored in `sessionStorage`, which we check to avoid
 * making duplicate bucketing calls to the server.
 * `sessionStorage` is cleared when the user closes their tab.
 */
export function abTest() {
  return __abTest_base(
    'bulk_download_2026_q2_modal_mechanics_smoke_test',
    TEST_CONFIG,
  );
}

/**
 * React hook to return the bucket for this A/B test:
 * bulk_download_2026_q2_modal_mechanics_smoke_test
 *
 * Returns the bucket based on the current logged-in user id.
 * Asynchronously records the test on the backend.
 */
export function useAbTest() {
  return __useAbTest_base(
    'bulk_download_2026_q2_modal_mechanics_smoke_test',
    TEST_CONFIG,
  );
}

/**
 * Returns whether the user is in the winner holdout for this A/B test:
 * bulk_download_2026_q2_modal_mechanics_smoke_test
 *
 * Returns true if all of the following are true:
 * - The test is finished
 * - The user is in the overall holdout
 * - The user is in the winner sub-holdout
 */
export function inWinnerHoldout() {
  return __inWinnerHoldout_base(
    'bulk_download_2026_q2_modal_mechanics_smoke_test',
    TEST_CONFIG,
  );
}

// MD5 hash of test's YAML config; modification will fail commit hook
// c51cfc216a52a8d4b6eef821df0ebfa2
